import sharedLabel from '../../translation'
import {ButtonState} from '../../types/Bids'
import type {ILabel} from '../../../../types'

export default {
    btnStatus: (status: ButtonState): ILabel => {
        if(status === ButtonState.placeBid) {
            return {
                de: 'Gebot abgeben',
                en: 'Place bid',
                es: 'Pujar por esta joya',
                fr: 'Commandez',
                nl: 'Bieden',
                it: 'Invia l\'offerta',
            }
        }
        if(status === ButtonState.pleaseWait) {
            return {
                de: 'Bitte warten...',
                en: 'Please wait...',
                es: 'Espere por favor...',
                fr: 'Veuillez patienter...',
                nl: 'Een moment alstublieft...',
                it: 'Attendere, per favore...',
            }
        }
        if(status === ButtonState.confirmBid) {
            return {
                de: 'Gebot bitte bestätigen',
                en: 'Please confirm bid',
                es: 'Confirmar puja',
                fr: 'Confirmez votre offre',
                nl: 'Bod svp bevestigen',
                it: 'Conferma l\'offerta',
            }
        }
        if(status === ButtonState.bidSuccessful) {
            return sharedLabel.bidSuccessful
        }
        if(status === ButtonState.chooseVariant) {
            return {
                de: 'Variante wählen',
                en: 'Choose variant',
                es: 'Escoger variante',
                fr: 'Choisir la variante',
                nl: 'Variant kiezen',
                it: 'Seleziona variante',
            }
        }
        if(status === ButtonState.variantSold) {
            return {
                de: 'Variante ausverkauft, bitte andere Variante wählen',
                en: 'This variant is sold. Please select another one',
                es: 'Variante agotado, por favor elija otro producto',
                fr: 'Variante épuisé, merci de choisir un autre produit.',
                nl: 'Variant is uitverkocht, kies een ander product',
                it: 'Variante esaurito, per favore selezioni un altro prodotto',
            }
        }
        if(status === ButtonState.productSold) {
            return {
                de: 'Produkt ausverkauft, bitte anderes Produkt wählen',
                en: 'This item is sold. Please select another one',
                es: 'Producto agotado, por favor elija otro producto',
                fr: 'Produit épuisé, merci de choisir un autre produit.',
                nl: 'Product is uitverkocht, kies een ander product',
                it: 'Prodotto esaurito, per favore selezioni un altro prodotto',
            }
        }
        if(status === ButtonState.loginAndBid) {
            return {
                de: 'Jetzt anmelden und mitbieten',
                en: 'Join now and start bidding',
                es: 'Regístrese ahora y puje',
                fr: 'Connectez-vous et commandez',
                nl: 'Aanmelden en meebieden',
                it: 'Registrati e partecipa',
            }
        }
        if(status === ButtonState.completeBidData) {
            return {
                de: 'Jetzt Bietdaten ergänzen und mitbieten',
                en: 'Update payment details to Start Bidding',
                es: 'Complete sus datos y puje con nosotros',
                fr: 'Cliquez et commandez au prix le plus bas affiché',
                nl: 'Activeren en meebieden',
                it: 'Inserisci i dati e fai un\'offerta',
            }
        }
        return {
            de: 'de: undefined button state',
            en: 'en: undefined button state',
            es: 'es: undefined button state',
            fr: 'fr: undefined button state',
            nl: 'nl: undefined button state',
            it: 'it: undefined button state',
        }
    }
}